<div class="form-group">
  <label [class.pflichtfeld]="required" class="primaryFontColor">{{name}}</label>

  <div class="input-group">
    <input type="text"
           class="form-control"
           [style.background-color]="!valid || !ibanChecksumValid ? '#FF7777' : ''"
           [ngModel]="valAsStr()"
           (ngModelChange)="setFromStr($event)"
           [placeholder]="placeholder"
           [ngbTooltip]="tooltip">
    <div *ngIf="noData" class="input-group-append">
      <button type="button" class="btn btn-outline-secondary pcButton" (click)="applyNoData()">&Uuml;berspringen</button>
    </div>
  </div>
  <span *ngIf="!valid">Falsche Anzahl von Zeichen.</span>
  <span *ngIf="!ibanChecksumValid">IBAN hat einen Fehler.</span>

</div>
